import { Button, kuiperClassNames } from '@opallabs/kuiper'
import { updateApprovalItemStatus } from '../../helpers'

export const getPropsForUpdate = (phaseItems, resendToDenied) => ({
  is_active: true,
  items: updateApprovalItemStatus(phaseItems),
  resendToDenied,
  status: 'active',
})

export const getSendApprovalHandler = (phaseItems, update, resendToDenied) =>
  // we bind here to ensure we return the update method
  // and not invoke it immediately. This will be run
  // higher up the chain as a callback.
  update.bind(
    this,
    getPropsForUpdate(phaseItems, resendToDenied),
    'sendForApproval'
  )

export const sendForApproval = (
  onClickSend,
  phaseItems,
  update,
  resendToDenied
) => {
  const sendApprovalHandler = getSendApprovalHandler(
    phaseItems,
    update,
    resendToDenied
  )
  onClickSend(sendApprovalHandler)
}

export const approvalOptionsContent = (onClickSend, phaseItems, update) => (
  <div className={kuiperClassNames('approvalOptions', 'hasBgColor', 'n10')}>
    <div className={kuiperClassNames('approvalOptions-copy')}>
      Who should be sent approval notifications?
    </div>
    <Button
      color="blue"
      label="Resend to all"
      onClick={sendForApproval.bind(
        this,
        onClickSend,
        phaseItems,
        update,
        false
      )}
      size="small"
    />
    <Button
      label="Only resend to declining users"
      onClick={sendForApproval.bind(
        this,
        onClickSend,
        phaseItems,
        update,
        true
      )}
      type="secondary"
      size="small"
    />
  </div>
)

export const approvalOptionsTrigger = (options) => (
  <Button
    className={options.className}
    color={options.color}
    label={options.label}
    onClick={() => {}}
  />
)

const getLabel = (status, requires_all_approvals) => {
  switch (status) {
    case 'denied':
      switch (requires_all_approvals) {
        case true:
          return 'Restart Approval Phase'
        default:
          return 'Resend All Approvals'
      }
    default:
      return 'Start Approval Phase'
  }
}

const getClassName = (status) => {
  let className = 'request-approval'
  if (status === 'active') {
    className += ' active'
  }
  return className
}

// exported for testing
export const getColor = (status) => (status === 'active' ? 'orange' : 'blue')

export const getApprovalButtonHash = (
  approvals,
  requires_all_approvals,
  status
) => {
  const approvalsMissing = approvals ? !approvals.length : true
  const disabled = approvalsMissing
  const color = getColor(status)
  const className = getClassName(status)
  const label = getLabel(status, requires_all_approvals)

  return {
    className,
    color,
    disabled,
    label,
  }
}
